"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_idle_timer_1 = __importDefault(require("react-idle-timer"));
var react_1 = __importStar(require("react"));
var thirtyMinutesInMilliseconds = 1800000;
var fiveSecondsInMilliseconds = 5000;
var storageKey = "idle_timeout_logout_time";
var IdleTimeout = function (props) {
    var onIdle = props.onIdle, timeout = props.timeout, debounce = props.debounce;
    var _a = (0, react_1.useState)(false), hasInitialized = _a[0], setHasInitialized = _a[1];
    var idleTimerRef = (0, react_1.useRef)(null);
    var hasEndTimePassed = function () {
        if (!hasInitialized) {
            // don't kick out the user until the endTime has been setup
            return false;
        }
        var endTime = localStorage.getItem(storageKey);
        if (!endTime) {
            return true;
        }
        return +endTime < +new Date();
    };
    var setEndTime = (0, react_1.useCallback)(function () {
        var newEndTime = +new Date() + (timeout || thirtyMinutesInMilliseconds);
        window.localStorage.setItem(storageKey, newEndTime.toString());
    }, [timeout]);
    var setInvalidSession = function (e) {
        window.localStorage.removeItem(storageKey);
        onIdle(e);
    };
    var onAppIdle = function (e) {
        var _a;
        if (hasEndTimePassed()) {
            setInvalidSession(e);
        }
        else {
            (_a = idleTimerRef.current) === null || _a === void 0 ? void 0 : _a.reset();
        }
    };
    var onAction = function (e) {
        if (hasEndTimePassed()) {
            setInvalidSession(e);
        }
        else {
            setEndTime();
        }
    };
    (0, react_1.useEffect)(function () {
        setEndTime();
        setHasInitialized(true);
    }, [setEndTime]);
    return (react_1.default.createElement(react_idle_timer_1.default
    // TODO: fix this type error as soon as possible
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    , __assign({ 
        // TODO: fix this type error as soon as possible
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ref: idleTimerRef, timeout: timeout || thirtyMinutesInMilliseconds, debounce: debounce || fiveSecondsInMilliseconds, onAction: onAction }, props, { onIdle: onAppIdle })));
};
exports.default = IdleTimeout;
//# sourceMappingURL=index.js.map